import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className,
  hover = false,
  ...props
}, ref) => {
  return <div ref={ref} className={cn('rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300', hover && 'hover:shadow-md hover:border-blue-200 hover:-translate-y-1', className)} {...props} data-id="element-237" />;
});
Card.displayName = 'Card';